import { ApiResponse, apiCall } from "./apiClient";
import { EmployeeCostCentersResponse } from "../models/costCenter/EmployeeCostCentersResponse";
import { ICostCenterListItem } from "../models/costCenter/costCenterListItem";
import { EmployeeCostCentersUpsert } from "../models/costCenter/EmployeeCostCentersUpsert";

export const getCostCenterItems = (
    signal: AbortSignal
): Promise<ApiResponse<ICostCenterListItem[]>> => {
    return apiCall<ICostCenterListItem[]>("costcenters/list", "GET", signal);
};

export const getEmployeeCostCenters = (
    signal: AbortSignal
): Promise<ApiResponse<EmployeeCostCentersResponse>> => {
    return apiCall<EmployeeCostCentersResponse>(
        "costcenters/employee",
        "GET",
        signal
    );
};

export const updateEmployeeCostCenters = (
    CostCenterIds: EmployeeCostCentersUpsert,
    signal: AbortSignal
): Promise<ApiResponse<void>> => {
    return apiCall<void>("costcenters/employee", "PUT", CostCenterIds, signal);
};
